module.exports = __webpack_public_path__ + "img/image-placeholder.3998813.png";